import { render, staticRenderFns } from "./MiGlobalSearch.vue?vue&type=template&id=9f3906e8&scoped=true"
import script from "@/components/mi-global-search/MiGlobalSearch.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-global-search/MiGlobalSearch.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-global-search/mi-global-search.scss?vue&type=style&index=0&id=9f3906e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3906e8",
  null
  
)

export default component.exports